import './styles.css';
const Box = ({ children }) => {
  return (
    <div className='box'>
      {children}
    </div>
  );
};

export default Box;